import { toast } from "sonner";

export const MAILTO_MAX = 1800;
const enc = (s) => encodeURIComponent(s || "").replace(/%0A/g, "%0D%0A");

export const fullMailto = (mail) =>
  `mailto:${mail.aan?.email || ""}?subject=${enc(mail.onderwerp)}&body=${enc(mail.tekst)}`;
const shortMailto = (mail) => `mailto:${mail.aan?.email || ""}?subject=${enc(mail.onderwerp)}`;

// De link die de knop écht opent (kort als de volledige tekst te lang is voor een mailto).
export const mailHref = (mail) => (fullMailto(mail).length <= MAILTO_MAX ? fullMailto(mail) : shortMailto(mail));

// De app verstuurt niets: dit opent een concept in het eigen mailprogramma van de gebruiker.
export async function openMailConcept(mail, { onCopyFailed, locatie, isOversight } = {}) {
  if (!mail.aan?.email) {
    toast.warning(`Geen e-mailadres bekend voor ${locatie}. Vul het in bij ${isOversight ? "Instellingen" : "Locatie-accounts"}.`);
  }
  const full = fullMailto(mail);
  if (full.length <= MAILTO_MAX) {
    window.location.href = full;
    return;
  }
  try {
    await navigator.clipboard.writeText(mail.tekst);
    toast.success("De tekst staat op je klembord. Plak hem in de mail.");
  } catch {
    onCopyFailed?.();
    toast.warning("Kopiëren lukte niet. De tekst is geselecteerd: kopieer hem met Ctrl+C en plak hem in de mail.");
  }
  window.location.href = shortMailto(mail);
}

export function selectNode(node) {
  if (!node) return;
  const range = document.createRange();
  range.selectNodeContents(node);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}
